module.exports = __webpack_public_path__ + "img/李梢.a31ff32c.png";